import $ from 'jquery';

export const filterQuotes = (filter) => {
  const items = $('.editor-sidebar-quotes-container');
  let isVisible = false;
  items.each((index) => {
    const quote = $(items[index])
      .find('.editor-sidebar-quote-box')
      .data('text')
      .toLowerCase();
    if (quote.toLowerCase().includes(filter)) {
      $(items[index]).show();
      isVisible = true;
    } else {
      $(items[index]).hide();
    }
  });
  if (!isVisible && $('#no-quotes-available').length === 0) {
    const html =
      '<div id="no-quotes-available" class="text-center mt-5 mb-4">Nessun testo trovato</div>';
    $('#editor-sidebar-quotes').append(html);
  } else if (isVisible) {
    if ($('#no-quotes-available').length) {
      $('#editor-sidebar-quotes').find('#no-quotes-available').remove();
    }
  }
};
